<template>
  <div>
    <Icon type="iconzanwu" class="iconZanwu"></Icon>
    <div class="zanwuContent">{{ title }}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "暂无信息"
    }
  }
};
</script>
<style lang="less" scoped>
.iconZanwu {
  width: 246px !important;
  height: 246px !important;
  margin: 260px auto 0 auto;
  display: block;
}

.zanwuContent {
  text-align: center;
  color: #ababab;
  font-size: 14px;
  margin-top: 73px;
  margin-bottom: 88px;
}
</style>
